import { useQuery } from '@tanstack/react-query';
import { getPayrollValueBandsChart } from '../../../services/repository/dashboardRepository';

// Compartilhado entre o gráfico e o card de valor da folha: mesma queryKey, uma única requisição
export default function usePayrollValueBandsChart({ folhaIds, competenciaInicial, competenciaFinal }) {
  return useQuery({
    queryKey: ['payroll-value-bands-chart', folhaIds, competenciaInicial, competenciaFinal],
    queryFn: () => getPayrollValueBandsChart({ folhaIds, competenciaInicial, competenciaFinal }),
  });
}
